import React, { useEffect, useState } from 'react';
import { View, StyleSheet, Pressable } from 'react-native';
import { Text } from '~/components/core';
import { FONT_SIZE_M, FONT_SIZE_XL } from '~/constants';
import { scaleSize, isDesktop } from '~/constants/scale';
import { useStyles } from '~/hooks';
import { Theme } from '~/theme';
import t from '~/i18n';
import ScrollbarWrapper from '~/components/core/ScrollbarWrapper';
import config from '~/config';
import { goBack } from '~/navigation';
import DesktopScreenHeader from '~/components/features/Desktop/DesktopScreenHeader';

type Props = {
    titleKey: string;
    bodyKey: string;
    extraBodyKey?: string;
    setActiveRightTab?: Function;
};

export default function LegalDocumentBody({ titleKey, bodyKey, extraBodyKey, setActiveRightTab }: Props) {
    const styles = useStyles(stylesGenerator);
    const [bodyText, setBodyText] = useState('');

    useEffect(() => {
        const messageContext: any = { brand: config.BRAND_NAME };
        const main = t.t(bodyKey, messageContext);
        setBodyText(extraBodyKey ? `${main}\r\n\r\n${t.t(extraBodyKey, messageContext)}` : main);
    }, [bodyKey, extraBodyKey]);

    const onClose = () => {
        if (isDesktop() && setActiveRightTab) {
            setActiveRightTab('legal-documents');
        } else {
            goBack();
        }
    };

    return (
        <ScrollbarWrapper style={styles.container}>
            {setActiveRightTab ? (
                <DesktopScreenHeader
                    title={titleKey}
                    goToScreenName="legal-documents"
                    setActiveRightTab={setActiveRightTab}
                />
            ) : null}
            <View style={styles.headContainer}>
                <Text fontType="LATO_ITALIC_BOLD" style={styles.headText}>
                    {t.t(titleKey)}
                </Text>
            </View>
            <View style={styles.contentContainer}>
                <View style={styles.body}>
                    <Text fontType="LATO_REGULAR" style={styles.bodyText}>
                        {bodyText}
                    </Text>
                </View>
                <View style={styles.closeContainer}>
                    <Pressable style={styles.closeButton} onPress={onClose}>
                        <Text fontType="LATO_BOLD" style={styles.closeButtonText}>
                            Close
                        </Text>
                    </Pressable>
                </View>
            </View>
        </ScrollbarWrapper>
    );
}

const stylesGenerator = (theme: Theme) =>
    StyleSheet.create({
        container: {
            flex: 1,
            height: '100%',
            justifyContent: 'flex-start',
            alignSelf: 'center',
            width: '100%',
        },
        headContainer: {
            width: '100%',
            backgroundColor: theme.switch_trackOn,
            justifyContent: 'center',
            alignItems: 'center',
            paddingVertical: scaleSize(20),
            paddingHorizontal: scaleSize(15),
        },
        headText: {
            fontSize: FONT_SIZE_XL,
            color: theme.white,
            textAlign: 'center',
        },
        contentContainer: {
            paddingHorizontal: scaleSize(25),
            backgroundColor: theme.background,
        },
        body: {
            paddingTop: scaleSize(20),
            paddingBottom: scaleSize(20),
        },
        bodyText: {
            fontSize: FONT_SIZE_M,
            color: theme.wallet_text,
        },
        closeContainer: {
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            paddingTop: scaleSize(10),
            paddingBottom: scaleSize(20),
        },
        closeButton: {
            width: scaleSize(100),
            height: scaleSize(25),
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: scaleSize(2),
            borderWidth: 1,
            borderColor: theme.background_closeTradeButton,
            backgroundColor: theme.background_closeTradeButtonPressed,
        },
        closeButtonText: {
            color: theme.background_closeTradeButton,
        },
    });
